import React, { useState } from 'react';
import HamQuest from './api/HamQuestGiver';
import ModalFactory from './Modal';
import { useGlobalState } from './stateProvider/StateProvider';
import { QuestRoute } from './api/QuestRoutes';
import Button from './forms/Button';
import Col from './layout/Col';

const FeatureTOS = ({ feature, children, ...props }) => {
    const {
        state: {
            active_user
        },
        updateAccessToken
    } = useGlobalState();

    const [show, setShow] = useState(false)

    const features = active_user.features || {};

    const acceptTOS = () => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: 'Family Planning',
                yesLabel: 'I Understand',
                body: (
                    <Col>
                        Stuff goes here!
                    </Col>
                ),
                closeAfter: true,
            },
            promise: {
                title: 'Accepting',
                callback: () => (
                    HamQuest.get(QuestRoute.acceptFeature(feature))
                        .then(async () => await updateAccessToken())
                )
            }
        })
    }

    return children;

    return features[feature] ? children : show ? children : (
        <Col>
            <Button
                onClick={() => setShow(true)}
                label='Show Anyway'
            />
            <Button
                onClick={acceptTOS}
                label='Enable Family Planning'
            />
        </Col>
    )
}

export default FeatureTOS;
